import { FileDropzone, FormControl, FormField, FormItem, FormLabel, FormMessage, Text } from "@sentricmusic/ui";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { extractFilenameToShow } from "@/features/gigs/utils/gigsClaimUtils";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

type EvidenceSectionProps = {
  isUpdate: boolean;
  currentEvidenceURL: string | undefined;
  onFileChange: (file: File) => void;
};

function EvidenceSection({ isUpdate, currentEvidenceURL, onFileChange }: EvidenceSectionProps) {
  const { t } = useTranslation("gigs");
  const formContext = useFormContext<GigClaimFormValues>();
  const [evidenceFile, setEvidenceFile] = useState<File | null>(null);

  return (
    <div>
      <Text as="subtitle">Evidence</Text>
      <div className="flex flex-col gap-2">
        <FormField
          control={formContext.control}
          name="evidenceURL"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>
                {t("gigs:add-evidence-text", "Add evidence of gig, such as a flyer. JPG, PNG or PDF accepted.")}
              </FormLabel>
              <FormControl>
                <FileDropzone
                  file={evidenceFile}
                  onFileAccepted={(file) => {
                    onFileChange(file);
                    setEvidenceFile(file);
                  }}
                  onClick={() => {
                    setEvidenceFile(null);
                    field.onChange(undefined);
                  }}
                  accept={{ "image/jpeg": [], "image/png": [], "application/pdf": [] }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {isUpdate && currentEvidenceURL != null && (
          <small className="font-semibold">
            {t("gigs:current-proof-of-performance", "Currently uploaded file:")}
            {" "}
            {extractFilenameToShow(currentEvidenceURL)}
          </small>
        )}
      </div>
    </div>
  );
}

export default EvidenceSection;
